import { keyBy } from "lodash";

import {
  IEntityDeleteSuccess,
  IEntityFetchCollectionSuccess,
  IEntityFetchSuccess,
  IEntityUpdateSuccess,
} from "store/entities/actions";
import { MailboxesAction, MailboxesActionsNames } from "store/entities/mailboxes/actions";
import { IMailbox } from "store/entities/mailboxes/interfaces";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "store/entities/reducer";

const initialState: IEntityCollectionState<IMailbox> = {};

export const mailboxesReducer = (
  state: IEntityCollectionState<IMailbox> = initialState,
  action: MailboxesAction
): IEntityCollectionState<IMailbox> => {
  switch (action.type) {
    case MailboxesActionsNames.FETCH_SINGLE.SUCCESS: {
      const { value } = action.payload as IEntityFetchSuccess<IMailbox>;
      return {
        ...state,
        [value.id]: value,
      };
    }

    case MailboxesActionsNames.FETCH_COLLECTION.SUCCESS: {
      const { values } = action.payload as IEntityFetchCollectionSuccess<IMailbox>;
      return keyBy(values, v => v.id);
    }

    case MailboxesActionsNames.CREATE.SUCCESS:
    case MailboxesActionsNames.UPDATE.SUCCESS: {
      const { value } = action.payload as IEntityUpdateSuccess<IMailbox>;
      // @ts-expect-error TS(2322): Type '{ [x: string]: IMailbox | undefined; }' is n... Remove this comment to see the full error message
      return {
        ...state,
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        [value.id]: value,
      };
    }

    case MailboxesActionsNames.DELETE.SUCCESS: {
      const { id } = action.payload as IEntityDeleteSuccess;
      // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: toDelete, ...restState } = state;
      return restState;
    }

    case MailboxesActionsNames.SYNC_DELETE: {
      const { id } = action.payload as IEntityDeleteSuccess;
      // @ts-expect-error TS(2464): A computed property name must be of type 'string',... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: toDelete, ...restState } = state;
      return restState;
    }

    default:
      return state;
  }
};
